import { render, staticRenderFns } from "./BatteryEmpty.vue?vue&type=template&id=1b47c4b5&"
import script from "./BatteryEmpty.vue?vue&type=script&lang=js&"
export * from "./BatteryEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports